import type { DocTypeSchema } from "./meta";

/**
 * Human title of a saved document, doctype-agnostic: the value of the doctype's
 * `title_field` when set, else the document `name`. Returns null when `doc` is
 * not an object (or has neither), so callers choose their own fallback.
 *
 * Shared by StandardDetailPage, GenericDetailContent and the active-detail-page
 * registry (plan 1968 page context).
 */
export function getDocTitle(
  meta: Pick<DocTypeSchema, "title_field"> | null | undefined,
  doc: unknown,
): string | null {
  if (!doc || typeof doc !== "object") return null;
  const record = doc as Record<string, unknown>;
  // Use title_field from meta if available (e.g., "title" for TikTok Listing)
  if (meta?.title_field && record[meta.title_field]) {
    return String(record[meta.title_field]);
  }
  return "name" in record ? String(record.name) : null;
}

const NON_VALUE_FIELDTYPES = new Set([
  "Table",
  "Table MultiSelect",
  "Section Break",
  "Column Break",
  "Tab Break",
  "HTML",
  "Fold",
]);

/** True when every required value field of a NEW document has a value. */
export function areRequiredFieldsFilled(
  meta: Pick<DocTypeSchema, "fields">,
  formData: Record<string, unknown>,
): boolean {
  return meta.fields
    .filter((f) => f.reqd === 1 && !NON_VALUE_FIELDTYPES.has(f.fieldtype))
    .every((f) => {
      const v = formData[f.fieldname];
      return v !== null && v !== undefined && v !== "";
    });
}
